// CreateSpecialistModal.jsx
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import {
  registerSpecialis,
  gettAllSpecialist,
} from "../../services/users/userService";
import { setListSpecialist } from "../../redux/slice/usersSlice";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const CreateSpecialistModal = ({ open, setOpen, setLoading }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    nickName: "",
    email: "",
    password: "",
    rol: "",
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "El nombre es requerido";
    if (!formData.email.trim()) {
      newErrors.email = "El email es requerido";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Ingrese un email válido";
    }
    if (!formData.password) {
      newErrors.password = "La contraseña es requerida";
    } else if (formData.password.length < 6) {
      newErrors.password = "La contraseña debe tener al menos 6 caracteres";
    }
    if (!formData.rol) newErrors.rol = "El rol es requerido";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!validateForm()) return setLoading(false);

    try {
      await registerSpecialis({ ...formData, origin: "web" });
      const list = await gettAllSpecialist();
      dispatch(setListSpecialist({ listSpecialist: list }));
      toast.success(
        "Especialista creado exitosamente. Pídale que valide su correo."
      );
      setOpen(false);
    } catch (err) {
      const { message } = handleError(err);
      toast.error(`No se pudo crear el especialista. ${message}`);
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Crear Nuevo Especialista</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label="Nombre"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                error={!!errors.firstName}
                helperText={errors.firstName}
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label="NickName"
                name="nickName"
                value={formData.nickName}
                onChange={handleChange}
                margin="normal"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
                margin="normal"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                required
                label="Rol"
                name="rol"
                value={formData.rol}
                onChange={handleChange}
                error={!!errors.rol}
                helperText={errors.rol}
                margin="normal"
              >
                <MenuItem value="Coach">Entrenador</MenuItem>
                <MenuItem value="Nutricionist">Nutriólogo</MenuItem>
                <MenuItem value="Psicology">Psicólogo</MenuItem>
                <MenuItem value="Physiotherapy">Fisioterapeuta</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Contraseña"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password}
                margin="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            variant="outlined"
            color="white"
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{ backgroundColor: "#e7ef7d" }}
          >
            Crear Especialista
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateSpecialistModal;
